import { Tooltip } from "antd";
import { ToolTipProps } from "./type";

function AntTooltip(props: ToolTipProps) {
  return <Tooltip destroyTooltipOnHide {...props} />;
}

export { AntTooltip as ToolTip };
